<template>
  <div class="ti-page-start py2">
    <div class="lg-section px3 pb1">
      <router-link :to="{name: 'vendor-list'}" class="ti-link">🡸 Vendors</router-link>
    </div>
    <div class="lg-section px3 pb1">
      <h2 class="detail-header-title inline">Compare Vendors</h2>
    </div>

    <div class="lg-section pb1">
      <div v-if="!loading && !canAccess" class="lg-section ml3">
        <div class="py3">
          <span class="ti-message ti-message-alert">
            You currently do not have permission to access this page.
            A subscription of <strong>ESSENTIAL</strong> or better is required.
          </span>
        </div>
      </div>

      <table v-if="!loading && canAccess" class="ti-tbl2 ti-tbl2-double">
        <thead>
          <tr class="ti-tbl-dark sticky-header">
            <th class="ti-tbl2-header" style="text-align:left;">Technology</th>
            <th v-for="vendor in vendors" :key="vendor.id"
                class="ti-tbl2-header bold">
              <router-link :to="{name: 'vendor-detail',
                                params: {id: vendor.id, slug:toSlug(vendor.name)}}"
                           target="_blank" class="flex-auto ti-link" style="color:black;">
                {{vendor.name}}
              </router-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="area in techTree">
            <tr :key="area.code" v-if="area.show"
                class="ti-tbl-tech">
              <th class="ti-tbl2-header ti-tbl2-border-left"
                  style="font-weight:bold;text-align:left;">
                {{area.label}}
              </th>
              <th colspan="10" class="ti-tbl2-border-right"/>
            </tr>
            <template v-for="role in area.roles">
              <template v-for="tech in role.items">
                <tr v-if="tech.show" :key="tech.id"
                    class="ti-tbl2-row">
                  <td :title="tech.def" class="ti-tbl2-border-left">
                    {{tech.label}}
                  </td>
                  <td v-for="vendor in vendors" :key="vendor.id" class="ti-tbl2-val"
                      :class="{'ti-tbl2-border-right': isLast(vendor)}">
                    <BarGauge :size="3" :val="vendor.tech[tech.id] || 0" class="px2"/>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </tbody>

        <tbody>
          <tr>
            <td colspan="100" style="line-height:50px; border-top: 1px solid #E5E5E5;">
              &nbsp;
            </td>
          </tr>
        </tbody>

        <thead class="mt3">
          <tr class="ti-tbl-vertical sticky-header">
            <th class="ti-tbl2-header ti-tbl2-border-left" style="text-align:left;">Vertical</th>
            <th v-for="vendor in vendors" :key="vendor.id"
                class="ti-tbl2-header bold">
              <router-link :to="{name: 'vendor-detail',
                                params: {id: vendor.id, slug:toSlug(vendor.name)}}"
                           target="_blank" class="flex-auto ti-link" style="color:black;">
                {{vendor.name}}
              </router-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="code in $store.state.refMap.vertical_items" :key="code"
              class="ti-tbl2-row">
            <td class="ti-tbl2-border-left">
              {{$store.state.refMap.verticals[code].label}}
            </td>
            <td v-for="vendor in vendors" :key="vendor.id" class="ti-tbl2-val"
                :class="{'ti-tbl2-border-right': isLast(vendor)}">
              <span v-if="hasVertical(vendor, code)">✓</span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

import BarGauge from '@/components/BarGauge.vue';

export default {
  name: 'VendorCompare',
  components: { BarGauge },
  data() {
    return {
      loading: true, // first load of refMap

      canAccess: null,
      vendors: null,
      techTree: null,
    };
  },

  computed: {
    lastVendorId() {
      return this.vendors[this.vendors.length - 1].id;
    },
  },

  created() {
    const params = {};
    if (this.$store.state.refMap === null) {
      // if page loaded from URL
      params.schema = '1';
    }
    const ids = this.$route.query.vendors;
    const postData = { ids };
    axios.post('/api/vendors/compare', postData, { params })
      .then((res) => {
        this.canAccess = res.data.canAccess;
        if (this.canAccess) {
          this.vendors = res.data.vendors;
          this.techTree = res.data.techTree;
          if (this.$store.state.refMap === null) {
            this.$store.commit('initMaps', res.data.refMap);
          }
        }
        this.loading = false;
      });
  },

  methods: {
    hasVertical(vendor, code) {
      return vendor.verticals.indexOf(code) !== -1;
    },
    isLast(vendor) {
      return vendor.id === this.lastVendorId;
    },
  },
};
</script>

<style>
</style>
